import React from 'react';
import { BrowserRouter, Routes, Route, NavLink } from 'react-router-dom';
import Leads from './components/Leads';
import AddLead from './components/AddLead';
import Import from './components/Import';
import Scraper from './components/Scraper';
import './App.css';

export default function App() {
  return (
    <BrowserRouter>
      <div className="app">
        <aside className="sidebar">
          <div className="sidebar-logo">V</div>
          <nav className="sidebar-nav">
            <NavLink to="/" end className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
              <span className="nav-label">leads</span>
            </NavLink>
            <NavLink to="/add" className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
              <span className="nav-label">add</span>
            </NavLink>
            <NavLink to="/import" className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
              <span className="nav-label">import</span>
            </NavLink>
            <NavLink to="/scraper" className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
              <span className="nav-label">scraper</span>
            </NavLink>
          </nav>
          <div className="sidebar-footer">
            <span className="kage">影</span>
          </div>
        </aside>
        <main className="main">
          <Routes>
            <Route path="/" element={<Leads />} />
            <Route path="/add" element={<AddLead />} />
            <Route path="/import" element={<Import />} />
            <Route path="/scraper" element={<Scraper />} />
          </Routes>
        </main>
      </div>
    </BrowserRouter>
  );
}
